
import { mixins } from 'vue-class-component';
import { RedemptionResult, ShopifySubmission, ShopifySubmissionResult } from '@/api/models';
import { CampaignShopifyProductDetails } from '@/api/shopify/types';
import CampaignWidgetMixin from '@/mixins/campaignWidget';
import WithCampaignConstants from '@/mixins/WithCampaignConstants';

export default class MRedemptionButtonSection extends mixins(
  WithCampaignConstants,
  CampaignWidgetMixin
) {
  modifying = false;

  // component methods
  get currentRedemption(): RedemptionResult {
    return this.state.activeRedemption;
  }

  get redemptionCompleted(): boolean {
    return (this.currentRedemption.submissions?.[0] as ShopifySubmissionResult)?.completed ?? false;
  }

  get selectedProduct(): CampaignShopifyProductDetails {
    const productId = (
      this.state.activeRedemption.submissions![0] as ShopifySubmission
    ).productId.toString();
    const productIndex = this.state.shopifyProducts!.findIndex(
      // @ts-ignore
      (product: CampaignShopifyProductDetails): boolean => product.productId === productId
    );
    // @ts-ignore
    return this.state.shopifyProducts![productIndex];
  }

  get hasMultipleVariantsForProduct(): boolean {
    return this.selectedProduct.productData.variants.length > 1;
  }

  get canModify(): boolean {
    // if have multiple variants, multiple products, or can select > 1 qty
    return (
      this.hasMultipleVariantsForProduct ||
      this.state.shopifyProducts!.length > 1 ||
      this.selectedProduct.limit > 1
    );
  }

  get showQueuePosition(): boolean {
    if (
      !this.redemptionCompleted &&
      this.state.campaignActionType === this.CampaignAction.SHOPIFY_DELAYED
    ) {
      return (
        !(this.currentRedemption.submissions?.[0] as ShopifySubmissionResult)?.redirect &&
        this.state.shopifyQueue
      );
    }
    // don't show if not shopify_delayed
    return false;
  }

  get shopifyInvoiceLink(): string {
    const submission = this.currentRedemption.submissions?.[0] as ShopifySubmissionResult;
    const invoiceUrl = submission?.redirect;
    if (typeof window.ManifoldShopifyURL === 'string') {
      return window.ManifoldShopifyURL.replaceAll(
        '<INVOICE_URL>',
        encodeURIComponent(submission?.redirect)
      ).replaceAll('<DRAFT_ORDER_ID>', submission?.orderId);
    }

    return invoiceUrl;
  }

  get activeTokenSlot(): number {
    const redemptionId = this.currentRedemption!.id;
    const slotPosition = this.state.shopifyQueue?.slots.find(
      (slot: any) => slot.id == redemptionId
    );
    return slotPosition?.slotNum || 0;
  }

  get mainCtaText(): string {
    return this.innerClaimText?.trim() || 'Checkout';
  }

  get disabledCtaText(): string {
    if (this.redemptionCompleted) {
      return 'Order completed';
    }
    return `Hang tight, there's ${this.activeTokenSlot} customer${
      this.activeTokenSlot === 1 ? '' : 's'
    } checking out ahead of you...`;
  }

  // on modify clicked
  async modifyClicked(): Promise<void> {
    this.modifying = true;
    await this.modifyCurrentRedemption();
    this.modifying = false;
  }
}
